import { UserType } from "./entities/User";

const fetchEnvSetting = (setting: string, required: boolean = false): string | undefined => {
  const value = process.env[setting];

  if (required && !value) {
    throw new Error(`Missing config variable: ${setting}`);
  }

  return value;
}

const nodeEnv = fetchEnvSetting('NODE_ENV', true)!;
const apiUrl = fetchEnvSetting('REACT_APP_API_URL', true)!;
const loginUrl = fetchEnvSetting('REACT_APP_LOGIN_URL', true)!;
const mountPath = fetchEnvSetting('REACT_APP_MOUNT_PATH', true)!;
const tokensEnabled = fetchEnvSetting('REACT_APP_TOKENS_ENABLED') !== 'false';
const archiveTermsAndConditionsUrl = 'https://www.ecmwf.int/sites/default/files/licence_agreement_for_ECMWF%20archive_products.pdf';
const dataCacheTtlMs = 60 * 60 * 1000; // 1 hour caching for global data
const serviceDeskEmail = 'servicedesk@ecmwf.int';

const tokenCustomer = fetchEnvSetting('REACT_APP_TOKEN_CUSTOMER');
const tokenCCP = fetchEnvSetting('REACT_APP_TOKEN_CCP');
const tokenAdmin = fetchEnvSetting('REACT_APP_TOKEN_ADMIN');

const tokens = new Map([
  [UserType.Customer, tokenCustomer],
  [UserType.Admin, tokenAdmin],
  [UserType.CCP, tokenCCP]
])

export const config = Object.freeze({
  nodeEnv,
  apiUrl,
  loginUrl,
  mountPath,
  archiveTermsAndConditionsUrl,
  dataCacheTtlMs,
  serviceDeskEmail,
  tokensEnabled,
  tokens
});
